module.exports = __webpack_public_path__ + "img/shot_img2.2e43939c.gif";